<div class="create-form-dialog__header">
  <h2>{{ payload().title }}</h2>
  <button type="button" aria-label="Close dialog" (click)="close()">
    <rx-icon name="close" class="dark cp"></rx-icon>
  </button>
</div>

@if (step() === 'options') {
  <p class="create-form-dialog__subtitle">Choose what you’d like to create</p>
  <div class="create-form-dialog__options">
    @for (option of options(); track option.type) {
      <lib-rx-form-option-card
        [icon]="option.icon"
        [title]="option.title"
        [description]="option.description"
        (selected)="selectOption(option)"
      ></lib-rx-form-option-card>
    }
  </div>
}

@if (step() === 'upload') {
  <div class="pdf-upload">
    <div class="pdf-upload__drop-zone">
      @if (!selectedFile()) {
        <label class="pdf-upload__selector">
          <span class="pdf-upload__info">
            <rx-icon name="icon-upload-device"></rx-icon>
            <span>Drag your form file here or <a>upload</a> it from your device</span>
            <small>Please upload high quality <strong>PDF</strong> form.</small>
          </span>
          <input type="file" accept="application/pdf" (change)="selectFile($event)" />
        </label>
      } @else {
        <div class="pdf-upload__selected">
          <div>File selected, click 'Next' button to Upload PDF.</div>
          <div class="pdf-upload__file">
            <span>{{ selectedFile()?.name }}</span>
            <button type="button" aria-label="Remove selected file" (click)="clearFile()">
              <rx-icon name="close" class="red"></rx-icon>
            </button>
          </div>
        </div>
      }
    </div>

    <div class="create-form-dialog__actions">
      <rx-button class="white" (clicked)="close()">Cancel</rx-button>
      <rx-button class="blue" [disabled]="!selectedFile()" (clicked)="continueToCategory()">Next</rx-button>
    </div>
  </div>
}

@if (step() === 'category') {
  @if (categoriesLoading() && categories().length === 0) {
    <div class="folder-list__loading">
      <rx-icon name="icon-spinner" [size]="30"></rx-icon>
    </div>
  } @else {
    <div class="folder-list">
      @for (category of categories(); track category.id) {
        <button
          type="button"
          class="folder-list__item"
          [class.folder-list__item--selected]="selectedCategory()?.id === category.id"
          (click)="selectCategory(category)"
        >
          <rx-icon name="icon-folder" class="folder-list__icon"></rx-icon>
          <span class="folder-list__content">
            <span class="folder-list__title">{{ category.name }}</span>
            <span class="folder-list__description">
              {{
                (payload().isRxStaff ? category.stock_forms_count || 0 : category.account_forms_count || 0) + ' item(s)'
              }}
            </span>
          </span>
        </button>
      } @empty {
        <div class="folder-list__empty">No folders available.</div>
      }
      @if (categoriesHasMore()) {
        <div class="load-more-bar flex aic jcc" [class.is-visible]="categoriesLoadingMore()">
          <rx-icon name="icon-spinner"></rx-icon>
          <span class="ml10">Loading more...</span>
        </div>
        <div
          appInfiniteScrollTrigger
          class="infinite-scroll-sentinel"
          [disabled]="categoriesLoadingMore()"
          (reached)="loadMoreCategories()"
        ></div>
      }
    </div>
  }
  <div class="create-form-dialog__actions">
    <rx-button class="white" (clicked)="close()">Cancel</rx-button>
    <rx-button class="blue" [disabled]="!selectedCategory()" (clicked)="submitPdf()">Next</rx-button>
  </div>
}
